import React from 'react'
import styled from 'styled-components'

const Bg = styled.div`
  min-height: 100vh;
  background: #fcf8f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Plus Jakarta Sans', 'Noto Sans', sans-serif;
`
const Card = styled.div`
  background: #fff;
  border-radius: 1.2rem;
  box-shadow: 0 4px 24px #e7d3db44;
  padding: 3rem 2.5rem;
  text-align: center;
  max-width: 400px;
`
const Title = styled.h1`
  color: #ef427c;
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 900;
`
const Desc = styled.p`
  color: #9a4c66;
  font-size: 1.1rem;
`

export default function ThankYou() {
  return (
    <Bg>
      <Card>
        <Title>感謝您的聯絡！</Title>
        <Desc>
          我們已收到您的需求，將盡快與您聯繫。
          <br />
          祝您有美好的一天！
        </Desc>
      </Card>
    </Bg>
  )
}
